import React from 'react';
import ReactDOM from 'react-dom';
import './ParkingtransportationLandingCSS.css';

class ParkingTransportationLandingComponent extends React.Component {

    constructor(props) {
        super(props);
        const isSpanish = window.location.pathname.slice(0, 4) === '/es' || window.location.pathname.slice(0, 4) === '/es/';

        this.state = {
            isSpanish,
        }
    }
    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-12 p-0">
                        <img className="img-fluid w-100 heading-image" alt="header"
                             src="/images/default-source/siteimages/page-headers/parkingtransportationresized.jpg"/>
                        <div
                            style={{position: 'absolute',left:0,right:0,bottom:0,background:'rgba(0,0,0,.4)',fontSize: 'calc(1.5em + 2.5vw)',fontWeight: 'bold',color:'white',fontFamily: 'Calibri, sans-serif'}}>
                            <div style={{position:'relative',left:'2%',width:'98%'}}>{this.state.isSpanish ? "ESTACIONAMIENTO Y TRANSPORTE" : "PARKING & TRANSPORTATION"}</div>
                        </div>
                    </div>
                </div>
                <div className="row text-center mt-2 h-100">
                    <div className="col-12 col-md-3 mt-2 mt-md-0">
                        <div className="row no-gutters light-blue-background h-100 align-items-center" style={{marginLeft:'-15px'}}>
                        <div className="col-12 ">
                                <a className="font-blue font-16-resp" href={this.state.isSpanish ? '/es/estacionamientoyTransporte/estacionamiento?node=2' : '/ParkingTransportation/parking?node=2'}>
                                {this.state.isSpanish ? "Estacionamiento y tarifas" : "Parking Rates And Directions"}
                            </a>
                            </div>
                            <div className="col-12 ">
                                <a className="font-blue font-16-resp" href={this.state.isSpanish ? '/es/estacionamientoyTransporte/estacionamiento?node=1' : '/ParkingTransportation/parking?node=1'}>
                                {this.state.isSpanish ? "Estacionamiento prepagado de descuento" : "Sky Harbor Discount Parking (Reservations)"}
                                </a>
                            </div>
                            <div className="col-12 ">
                                <a className="font-blue font-16-resp" href={this.state.isSpanish ? '/ParkingTransportation/valet-parking ' : '/ParkingTransportation/valet-parking '}>
                                    {this.state.isSpanish ? "Estacionamiento con servicio de valet" : "Valet Parking"}
                                </a>
                            </div>
                            
                            
                            
                            <div className="col-12 "><a className="font-blue font-16-resp" href={this.state.isSpanish ? '/es/PHXSkyTrainEnEspanol ' : '/PHXSkyTrain'}>
                                PHX Sky Train&reg;
                            </a>
                            </div>
                            
                        </div>
                    </div>
                    <div className="col-12 col-md-3 mt-2 mt-md-0">
                        <div className="row no-gutters light-blue-background h-100 align-items-center">
                            
                            <div className="col-12 ">
                                <a className="font-blue font-16-resp" href={this.state.isSpanish ? '/es/estacionamientoyTransporte/PickupAndDropoffEnEspanol ' : '/ParkingTransportation/pick-up-drop-off'}>
                                    {this.state.isSpanish ? "Recoger y dejar pasajeros" : "Pick Up & Drop Off"}
                                </a>
                            </div>
                            <div className="col-12">
                                <a className="font-blue font-16-resp" href={this.state.isSpanish ? '/es/estacionamientoyTransporte/celular ' : '/ParkingTransportation/CellPhoneLots' }>
                                    {this.state.isSpanish ? "Área de espera de llamadas por teléfono celular" : "Cell Phone Waiting Lots"}
                                </a>
                            </div>
                            <div className="col-12">
                                <a className="font-blue font-16-resp" href={this.state.isSpanish ? '/es/estacionamientoyTransporte/RentalCarsEnEspanol ' : '/ParkingTransportation/RentalCars' }>
                                    {this.state.isSpanish ? "Renta de Automóviles" : "Rental Cars"}
                                </a>
                            </div>
                            
                        </div>
                    </div>
                    <div className="col-12 col-md-3 mt-2 mt-md-0">
                        <div className="row no-gutters light-blue-background h-100 align-items-center">
                        <div className="col-12">
                                <a className="font-blue font-16-resp" href={this.state.isSpanish ? '/es/estacionamientoyTransporte/taxis-y-servicio-de-transporte-privado ' : '/ParkingTransportation/TaxisAndShuttles'}>
                                    {this.state.isSpanish ? "Taxis y servicio de transporte privado" : "Taxis, Vans & Limos"}
                                </a>
                            </div>
                            <div className="col-12">
                                <a className="font-blue font-16-resp" href={this.state.isSpanish ? '/es/estacionamientoyTransporte/transporte-compartido ' : '/ParkingTransportation/ride-share' }>
                                    {this.state.isSpanish ? "Transporte compartido" : "Ride Share"}
                                </a>
                            </div>
                            
                            
                            <div className="col-12">
                                <a className="font-blue font-16-resp" href={this.state.isSpanish ? '/es/estacionamientoyTransporte/taxis-y-servicio-de-transporte-privado/StatewideShuttlesEnEspanol' : '/ParkingTransportation/TaxisAndShuttles/IntercityShuttles' }>
                                    {this.state.isSpanish ? "Transporte privado en todo el estado" : "Statewide Shuttles"}
                                </a>
                            </div>
                            <div className="col-12">
                                <a className="font-blue font-16-resp" href={this.state.isSpanish ? '/es/estacionamientoyTransporte/PublicTransportationEnEspanol ' : '/ParkingTransportation/PublicTransportation'}>
                                {this.state.isSpanish ? "Transporte publico" : "Public Transportation"}
                                </a>
                            </div>
                            <div className="col-12">
                                <a className="font-blue font-16-resp" href={this.state.isSpanish ? '/es/estacionamientoyTransporte/taxis-y-servicio-de-transporte-privado' : '/ParkingTransportation/TaxisAndShuttles' }>
                                {this.state.isSpanish ? "Vehículos accesibles - (bajo la Ley de Americanos con Discapacidades)" : "ADA Accessible Vehicles"}
                            </a>
                            </div>
                            <div className="col-12">
                                <a className="font-blue font-16-resp" href={this.state.isSpanish ? '/es/estacionamientoyTransporte/BikingEnEspanol ' : '/ParkingTransportation/Biking' }>
                                    {this.state.isSpanish ? "Andar en bicicleta hacia Sky Harbor" : "Bicycling to Sky Harbor"}
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-3 mt-2 mt-md-0">
                        <div className="row no-gutters light-blue-background h-100 align-items-center" style={{marginRight:'-15px'}}>
                        <div className="col-12">
                                <a className="font-blue font-16-resp" href='/ParkingTransportation/RoadwayRestrictions'>
                                    {this.state.isSpanish ? "Restricciones del camino" : "Roadway Restrictions"}
                                </a>
                            </div>
                            
                            <div className="col-12">
                                <a className="font-blue font-16-resp" href={this.state.isSpanish ? '/Business/TenantsAndContractors/GroundTransportation ' : '/Business/TenantsAndContractors/GroundTransportation '}>
                                {this.state.isSpanish ? "Oficina de transporte terrestre" : "Ground Transportation Office"}
                            </a>
                            </div>
                            {/*<div className="col-12 pb-4">*/}
                                {/*<a className="font-blue font-16-resp" href={this.state.isSpanish ? '' : ''}>*/}
                                {/*{this.state.isSpanish ? "FAQ" : "FAQ"}*/}
                            {/*</a>*/}
                            {/*</div>*/}

                        </div>
                    </div>
                </div>

            </div>
        )
    }
}


let domContainer = document.querySelector('#parking-transportation-landing');

if (!(domContainer === undefined || domContainer === null) === true) ReactDOM.render(
    <ParkingTransportationLandingComponent/>, domContainer);